import React from 'react';
import AsyncLoading from '@components/AsyncLoading/AsyncLoading';
import {
	NAME,
	reducer,
} from '@routes/Home/routes/AdminPortal/routes/SchoolManage/modules/Module';
import SchoolManageIndex from '@routes/Home/routes/AdminPortal/routes/SchoolManage/routes/SchoolManageIndex';
import SchoolInformation from '@routes/Home/routes/AdminPortal/routes/SchoolManage/routes/SchoolInformation';
import SubjectSetup from '@routes/Home/routes/AdminPortal/routes/SchoolManage/routes/SubjectSetup';
import GradesSetup from '@routes/Home/routes/AdminPortal/routes/SchoolManage/routes/GradesSetup';
import SectionSetup from '@routes/Home/routes/AdminPortal/routes/SchoolManage/routes/SectionSetup';
import StudentsSetup from '@routes/Home/routes/AdminPortal/routes/SchoolManage/routes/StudentsSetup';
import StaffSetup from '@routes/Home/routes/AdminPortal/routes/SchoolManage/routes/StaffSetup';
import SemesterSetup from '@routes/Home/routes/AdminPortal/routes/SchoolManage/routes/SemesterSetup';
import NonTeachingStaff from '@routes/Home/routes/AdminPortal/routes/SchoolManage/routes/NonTeachingStaff';

const SchoolManageLazy = React.lazy(
	() =>
		import(/* webpackChunkName : 'SchoolManage' */ './components/SchoolManage')
);

export default (store) => {
	store.injectReducer(NAME, reducer);

	return {
		path: 'school-manage',
		element: (
			<AsyncLoading
				component={<SchoolManageLazy permission="CanViewSchoolManagementHub" />}
			/>
		),
		children: [
			SchoolManageIndex(store),
			SchoolInformation(store),
			SubjectSetup(store),
			GradesSetup(store),
			SemesterSetup(store),
			...SectionSetup(store),
			...StudentsSetup(store),
			...StaffSetup(store),
			...NonTeachingStaff(store),
		],
	};
};
